/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function() {
  if($(window).width() > 999){
    $(window).on('load',function(){
      setTimeout(function(){
        $('.template-index .product-list').each(function(){
          let prod = $(this);
          let max = 0;
          prod.find('.product-item').each(function(){
            let ch = $(this);
            let h = ch.outerHeight(true) ;
            if(max < h){
              max = h;
            }
          })
          prod.find('.flickity-viewport').css('height',max+'px')
        })

      },1000)
    })
  }
  $(document).on('click', '.nav-tabs a', function(e) {
    e.preventDefault();    
    var _this = $(this);
    var index = _this.closest('li').index();
//     var attr = _this.attr('href');
    _this.attr('aria-expanded',true).closest('li').addClass('active').siblings('li').removeClass('active').find('a').attr('aria-expanded',false);
    $('.tab-content').find('.tab-pane').eq(index).addClass('active').siblings('.tab-pane').removeClass('active');
  })





var txt = $('.product-form__variants .product-form__selected-value').text();
  var str = 'Default Title';
 if (txt == str) {
       $('.product-form__variants').remove();
}












  
})